module.exports = __webpack_public_path__ + "img/课程中心.944935d6.png";